export default __webpack_public_path__ + "static/media/Dove.52506a52.svg";